import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { t } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Mail, MailOpen } from "lucide-react";
import { logWarn } from "@/lib/logger";

export default function NotificationsInbox() {
  const { lang } = useApp();
  const [items, setItems] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data); }
    catch (e) { logWarn("Notifications load failed", e); }
  };
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    setItems((prev) => prev.map((n) => n.id === id ? { ...n, read: true } : n));
  };

  return (
    <Card className="bg-[#FFFAF0] border-[#D8CFBB] p-6" data-testid="notifications-inbox">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#C5A880] mb-1">{t("pec_receipt", lang)}</p>
          <h3 className="text-2xl font-light" style={{ fontFamily: "Cormorant Garamond, serif" }}>{t("notifications", lang)}</h3>
        </div>
        <Badge className="bg-[#EBE3D3]/60 text-[#1A1610]" data-testid="notifications-count">
          {items.filter((n) => !n.read).length} nuove
        </Badge>
      </div>
      {!items.length && <p className="text-sm text-[#9A8B72] py-10 text-center">{t("no_data", lang)}</p>}
      <div className="space-y-3">
        {items.map((n) => (
          <div
            key={n.id}
            data-testid={`notification-${n.id}`}
            className={`rounded-md border p-4 ${n.read ? "border-[#E5DDC9] bg-transparent" : "border-[#C5A880]/40 bg-[#C5A880]/[0.03]"}`}
          >
            <div className="flex items-start gap-3">
              <div className="mt-1">
                {n.read ? <MailOpen className="h-4 w-4 text-[#B8A98F]" /> : <Mail className="h-4 w-4 text-[#C5A880]" />}
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-3 flex-wrap">
                  <p className="text-sm text-[#1A1610] font-medium">{n.subject}</p>
                  <p className="text-[11px] text-[#9A8B72] font-mono">{new Date(n.created_at).toLocaleString()}</p>
                </div>
                <p className="text-sm text-[#4A3F30] mt-1 leading-relaxed">{n.body}</p>
                {!n.read && (
                  <Button size="sm" variant="ghost" onClick={() => markRead(n.id)} data-testid={`mark-read-${n.id}`} className="text-[#C5A880] hover:bg-[#EBE3D3] mt-2 h-7 px-2">
                    {t("mark_read", lang)}
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
